// Referencing SCSS Breakpoint Variables
export const BREAKPOINT_FOR_IMG = 721;